<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat>
        <v-toolbar-title>Stock Adjustment Report</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>

          <v-col cols="12" xs="12" sm="12" md="4">
            <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
              offset-y min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field dense outlined single-line v-model="StartDate" label="From"
                  prepend-icon="mdi-calendar-month" v-on="on" readonly></v-text-field>
              </template>
              <v-date-picker v-model="StartDate" @input="menu1 = false"></v-date-picker>
            </v-menu>
          </v-col>

          <!-- datepicker 2 -->
          <v-col cols="12" xs="12" sm="12" md="4">
            <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
              offset-y min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field dense outlined single-line v-model="EndDate" label="To" prepend-icon="mdi-calendar-month"
                  v-on="on" readonly></v-text-field>
              </template>
              <v-date-picker v-model="EndDate" @input="menu2 = false"></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="3">
            <v-btn color="primary" @click="getRecords" :loading="loader">Query Data</v-btn>
          </v-col>

          <v-col cols="12" xs="12" md="12">
            <v-btn icon>
              <download-excel :data="stockReport" :fields="fields" name="Stock Adjustment Report">
                <v-icon color="green">mdi-file-excel</v-icon>
              </download-excel>
            </v-btn>
            <!-- start of table -->
            <v-data-table :items-per-page="2000" loading-text="Loading Data......" :headers="headers"
              :items="stockReport" :search="search" :mobile-breakpoint="0">
              <template v-slot:item.DocDate="{ item }">
                <span>{{ item.DocDate | date }}</span>
              </template>

               <template v-slot:item.Direction="{ item }">
                <span v-if="item.Direction == 0" style="color: red; font-weight: bold">Reduced</span>
                <span v-if="item.Direction == 1" style="color: green; font-weight: bold">Added</span>
              </template>
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>
      </v-card-text>
      <!-- snackbar -->
      <snackbar ref="snackbar"></snackbar>
    </v-card>
  </v-container>
</template>

<script>
export default {
  computed: {
    activeStore() {
      return localStorage.getItem("store_id");
    },
    storeName() {
      return localStorage.getItem("storeName");
    },
  },
  data() {
    return {
      search: null,
      queryCategory: null,
      categories: [],
      stockReport: [],
      pageItems: 500,
      loader: false,
      editItem: {},
      damagedItem: {},
      transferItem: {},
      smsRef: null,
      store: null,
      stores: [],
      users: [],
      StartDate: null,
      EndDate: null,
      date: null,
      menu1: false,
      menu2: false,
      dialog: false,
      damageDialog: false,
      transferDialog: false,
      headers: [
        { text: "Product Name", value: "ProductName" },
        { text: "Quantity", value: "Quantity" },
        { text: "Direction", value: "Direction" },
        { text: "Date", value: "DocDate" },
      ],
      fields: {
        Product: "ProductName",
        Previous: "AvailableQtyBefore",
        Correct: "Quantity",
        Variance: "diff",
      },
      inventory: [],
    };
  },
  methods: {
    setDate(date) {
      this.date = date;
    },
    openModal(item) {
      this.editItem = Object.assign({}, item);
      this.dialog = true;
    },
    openDamageModal(item) {
      this.damagedItem = Object.assign({}, item);
      this.damageDialog = true;
    },
    openTransferModal(item) {
      this.transferItem = Object.assign({}, item);
      this.transferDialog = true;
    },
    getRecords() {
      let data = {};
      data.StartDate = this.StartDate;
      data.EndDate = this.EndDate;
      data.store_id = this.activeStore;
      const self = this;
      const url = `/stock-adjustment-report`;
      this.$store.commit("loader", true);
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          console.log(res, "stock audit res");
          if (res.ResultCode == 1200) {
            self.stockReport = res.ResponseData;
            self.$store.commit("loader", false);
          } else {
            this.$refs.snackbar.show(res.msg, "red");
            self.$store.commit("loader", false);
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() { },
};
</script>

<style lang="scss" scoped></style>